import { Link } from 'react-router-dom';
import { Home, Mail } from 'lucide-react';
import smartDNALogo from '@/assets/smartdna-logo.png';


export function Footer() {
  return (
    <footer className="bg-foreground text-background mt-auto">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center">
                <Home className="w-5 h-5 text-primary-foreground" />
              </div>
              <span className="font-display text-xl font-semibold">Book A Viewing</span>
            </Link>
            <p className="text-background/70 text-sm">
              Search properties and book viewings online — no phone calls needed. Find your next home on your own terms.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-background/70">
              <li><Link to="/search" className="hover:text-background transition-colors">Search Properties</Link></li>
              <li><Link to="/map" className="hover:text-background transition-colors">Map View</Link></li>
              <li><Link to="/blog" className="hover:text-background transition-colors">Blog</Link></li>
              <li><Link to="/about" className="hover:text-background transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-background transition-colors">Contact</Link></li>
              <li><Link to="/dashboard/favorites" className="hover:text-background transition-colors">Saved Properties</Link></li>
              <li><Link to="/privacy" className="hover:text-background transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-background transition-colors">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Cities & Areas */}
          <div>
            <h3 className="font-semibold mb-4">Cities & Areas</h3>
            <ul className="space-y-2 text-sm text-background/70">
              <li><Link to="/edmonton" className="hover:text-background transition-colors font-medium">Edmonton Homes</Link></li>
              <li><Link to="/edmonton/south-edmonton-homes-for-sale" className="hover:text-background transition-colors pl-3">South Edmonton</Link></li>
              <li><Link to="/edmonton/southwest-edmonton-homes-for-sale" className="hover:text-background transition-colors pl-3">Southwest Edmonton</Link></li>
              <li><Link to="/edmonton/southeast-edmonton-homes-for-sale" className="hover:text-background transition-colors pl-3">Southeast Edmonton</Link></li>
              <li><Link to="/calgary" className="hover:text-background transition-colors font-medium">Calgary Homes</Link></li>
            </ul>
          </div>

          {/* Property Types */}
          <div>
            <h3 className="font-semibold mb-4">Property Types</h3>
            <ul className="space-y-2 text-sm text-background/70">
              <li><Link to="/search?type=House" className="hover:text-background transition-colors">Houses</Link></li>
              <li><Link to="/search?type=Condo" className="hover:text-background transition-colors">Condos</Link></li>
              <li><Link to="/search?type=Townhouse" className="hover:text-background transition-colors">Townhouses</Link></li>
              <li><Link to="/search?type=Land" className="hover:text-background transition-colors">Land</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm text-background/70">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@bookviewing.ca" className="hover:text-background transition-colors">
                  info@bookviewing.ca
                </a>
              </li>
            </ul>
            <div className="mt-3">
              <p className="text-sm text-background/80 font-semibold whitespace-nowrap">smartPRO REALTY</p>
              <p className="text-xs text-background/60 mt-1">
                Official brokerage site:{' '}
                <a
                  href="https://smartprorealty.ca"
                  rel="noopener noreferrer me"
                  target="_blank"
                  className="underline hover:text-background transition-colors"
                >
                  smartprorealty.ca
                </a>
              </p>
            </div>
            <p className="text-background/40 text-xs mt-1">
              No phone calls required — book viewings directly online.
            </p>
          </div>
        </div>

        {/* MLS Disclaimer */}
        <div className="border-t border-background/10 mt-8 pt-8">
          <div className="text-xs text-background/40 space-y-4">
            <p>
              Copyright 2026 by the REALTORS® Association of Edmonton. All rights reserved. 
              REALTORS® Association of Edmonton assumes no responsibility for the accuracy of any information shown. 
              Data is deemed reliable but is not guaranteed accurate by the REALTORS® Association of Edmonton. 
              Data was last updated 2026.01.04 12:00 AM EST.
            </p>
            <p>
              The trademarks REALTOR®, REALTORS®, and the REALTOR® logo are controlled by The Canadian Real Estate 
              Association (CREA) and identify real estate professionals who are members of CREA. The trademarks MLS®, 
              Multiple Listing Service®, and the associated logos are owned by CREA and identify the quality of 
              services provided by real estate professionals who are members of CREA.
            </p>
            <p>
              Copyright 2026 All rights reserved. Disclaimer: Data supplied by Pillar 9™ MLS® System. Pillar 9™ is 
              the owner of the copyright in its MLS® System. The Listing data is deemed reliable but is not guaranteed 
              accurate by Pillar 9™. The trademarks MLS®, Multiple Listing Service® and the associated logos are owned 
              by The Canadian Real Estate Association (CREA) and identify the quality of services provided by real 
              estate professionals who are members of CREA. Used under license. The trademarks REALTOR®, REALTORS®, 
              and the REALTOR® logo are controlled by The Canadian Real Estate Association (CREA) and identify real 
              estate professionals who are members of CREA. Used under license.
            </p>
            <p>
              Independently Owned and Operated by smartPRO REALTY.
            </p>
          </div>
        </div>

        <div className="border-t border-background/10 mt-6 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background/50">
          <p>&copy; {new Date().getFullYear()} Book A Viewing. All rights reserved.</p>
          <a 
            href="https://smartdna.io" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 hover:text-background transition-colors"
          >
            <img src={smartDNALogo} alt="smartDNA.io" className="w-4 h-4" />
            <span className="text-xs">Powered by</span>
            <span className="font-semibold">smartDNA.io</span>
          </a>
        </div>
      </div>
    </footer>
  );
}